export enum SocialMediaNames {
  FACEBOOK = 'facebook',
  TWITTER = 'twitter',
  YOUTUBE = 'youtube',
  WHATSAPP = 'whatsapp',
  LINKEDIN = 'linkedin',
  INSTAGRAM = 'instagram',
  MEDIUM = 'medium',
  GITHUB = 'github',
  DISCORD = 'discord',
  WEBSITE = 'website',
  PINTEREST = 'pinterest',
}
